import { Button } from "../../core/Button";

import { TPrimaryButtonProps } from "./PrimaryButton.type";

export default function PrimaryButton({
  text,
  type,
  onClick,
  styles,
  disabled,
  loading,
}: TPrimaryButtonProps) {
  return (
    <Button
      type={type}
      text={text}
      onClick={onClick}
      className={styles}
      disabled={disabled}
      loading={loading}
    />
  );
}
